import { logger } from '../../utils/src/logger';

export const formatNumberByLocale = (numb: number | string, lang: string): string => {
  const { log } = logger({})('formatNumberByLocale');
  log.debug(
    `[PerfTesting][utils] Entering the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  const inputStr = numb ?? '';
  // convert input number to locale string according to the lang
  // const str = Number(inputStr).toLocaleString(lang || '');
  let str = '';
  switch (lang) {
    case 'ko-KR':
    case 'ja-JP':
    case 'it-IT':
    case 'fr-FR':
    case 'de-DE':
    case 'ru-RU':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2 });
      break;
    case 'pt-BR':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 3 });
      break;
    case 'es-ES':
      str = Number(inputStr)?.toLocaleString(lang || '', { maximumFractionDigits: 2, useGrouping: true });
      break;
    case '':
    case undefined:
      str = Number(inputStr)?.toLocaleString();
      break;
    default:
      str = Number(inputStr)?.toLocaleString(lang || '');
      break;
  }
  log.debug(
    `[PerfTesting][utils] Exiting the formatNumberByLocale lang:${lang} function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`
  );
  return str;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getCtaUrl = (node: any, currentLocale?: string) => {
  const seoNickname = node?.seoNickname || node?.property?.seoNickname;
  const subDirectoryVal = currentLocale?.toLowerCase();
  return `/${subDirectoryVal}/hotels/${seoNickname}/overview/`;
};

type BrandCtx = { brandSection: string; brandName: string };

function getBrandPathParts(pathname: string): BrandCtx {
  const parts = (pathname || '').split('/').filter(Boolean);
  const brandSection = parts[0] ?? '';
  const brandName = (parts[1] ?? '').replace(/\.mi$/i, '');
  return { brandSection, brandName };
}

export const getViewAllUrl = (brandPath: string, currentLocale?: string) => {
  const { brandSection, brandName } = getBrandPathParts(brandPath);
  const subDirectoryVal = currentLocale?.toLowerCase();

  const localeSegment = subDirectoryVal && subDirectoryVal !== 'en-us' ? `/${subDirectoryVal}` : '';

  return `${localeSegment}/${brandSection}/${brandName}/locations.mi`;
};
